module.exports = __webpack_public_path__ + "img/hand_click.57489d7e.svg";